import React from 'react';

const Form = ({value, onChange, onCreate, onKeyPress, color}) => {
    return (
        <div className='form'>
            {/* ToDoListTemplete컴포넌트에서 4개의 props값을 받아온다 
            value: 사용자가 input 태그에 입력한 내용
            onCreate : 버튼이 클릭되면 실행되는 함수
            onChange : input내용이 변경이 될 때 실행되는 함수
            onKeyPress : input에 키를 입력할 때 실행되는 함수, enter키를 눌러도 onCreate를 실행한 것과 동일하게 적용하기 위함*/}
            <input type="text" value={value} onChange={onChange} onKeyPress={onKeyPress} style={{color}}/>
            <div className='create-button' onClick={onCreate}>추가</div>
        </div>
    );
}

export default Form;